export enum VideoStatusEnum {
  PROCESSING = 'processing',
  AVAILABLE = 'available',
  REMOVED = 'removed',
}
